/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import OnChangeInputField from "../../components/onChangeInputField/OnChangeInputField";
import Button from "../../components/button/Button";
import styles from "./InsertUser.module.css";
import { apiUrl } from "../../constants";

const InsertUser = () => {
  const [errorMessage, setErrorMessage] = useState(false);
  const [displayNewUserForm, toggleDisplayNewUserForm] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user");
  const [errorFirstName, toggleErrorFirstName] = useState(false);
  const [errorLastName, toggleErrorLastName] = useState(false);
  const [errorEmail, toggleErrorEmail] = useState(false);
  const [dataReady, setDataReady] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [success, toggleSuccess] = useState(false);
  const [ready, setReady] = useState(false);
  const [databaseErrorMessage, setDatabaseErrorMessage] = useState(
    "Something went wrong with sending the data, please try again later."
  );

  // When we load the page we clear all the state
  useEffect(() => {
    clearState();
  }, []);

  // Here we clear the state.
  function clearState() {
    setFirstName("");
    setLastName("");
    setDisplayName("");
    setEmail("");
    setRole("user");
    toggleErrorFirstName(false);
    toggleErrorLastName(false);
    toggleErrorEmail(false);
    setErrorMessage(false);
  }

  // When the input fields get data the state is updated and error messages (if there are any) will be removed.
  const handleChange = (e, target) => {
    let input = e.target.value;
    if (target === "firstName") {
      toggleErrorFirstName(false);
      setFirstName(input);
    }
    if (target === "lastName") {
      toggleErrorLastName(false);
      setLastName(input);
    }
    if (target === "email") {
      toggleErrorEmail(false);
      setEmail(input);
    }
  };

  // Here we check the errors on submit.
  function onSubmit(e) {
    e.preventDefault();
    checkErrors();
  }

  // When an input field is empty we display the error message. Role is always filled in so we have display error messages when react knows when role is there.
  function checkErrors() {
    if (role) {
      if (!firstName) {
        toggleErrorFirstName(true);
      }
      if (!lastName) {
        toggleErrorLastName(true);
      }
      if (!email) {
        toggleErrorEmail(true);
      } else {
        setReady(true);
      }
    }
  }

  // When all the input fields are filled in we can set the displayName in the database
  useEffect(() => {
    async function createDisplayName() {
      setDisplayName(firstName.toLowerCase() + lastName.toLowerCase());
    }
    if (ready) {
      createDisplayName();
    }
  }, [ready]);

  // When we have the display name everything is ready to be send to the database.
  useEffect(() => {
    if (displayName) {
      setDataReady(true);
    }
  }, [displayName]);

  // Here we send the data to the database and on success we can activate the send email function.
  useEffect(() => {
    async function sendData() {
      setErrorMessage(false);
      toggleLoading(true);
      const jwtToken = localStorage.getItem("token");
      try {
        await axios.post(
          `${apiUrl}/api/auth/newuser`,
          {
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            displayName: displayName.trim(),
            mobile: "",
            email: email.trim(),
            verified: "True",
            pwdHash: "",
            pwdChangedAt: "",
            tfaEnabled: "",
            active: "",
            updatedAt: "",
            resetToken: "",
            tokenExpiration: "",
            role: role,
          },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );

        toggleDisplayNewUserForm(false);
        toggleSuccess(true);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          setDatabaseErrorMessage(e.response.data.message);
        }
        setErrorMessage(true);
      }
      toggleLoading(false);
    }

    if (dataReady) {
      sendData();
    }
  }, [dataReady]);

  // Here we send the email to the user to set the password.
  useEffect(() => {
    async function sendEmail() {
      try {
        await axios.post(`${apiUrl}/api/auth/password/reset`, {
          email: email,
        });
      } catch (e) {
        console.error(e);
      }
    }

    if (success) {
      sendEmail();
    }
  }, [success]);

  return (
    <div className={styles["new-user-form-wrapper"]}>
      {displayNewUserForm && (
        <div className={styles["new-user-form"]}>
          <form onSubmit={onSubmit}>
            <h4>Add new user</h4>
            <section>
              <OnChangeInputField
                label="First name"
                name="firstName"
                type="text"
                id="first-name-field"
                onChange={(e) => handleChange(e, "firstName")}
                value={firstName}
              />
              <div className={styles["insert-user-error-wrapper"]}>
                {errorFirstName && (
                  <p className={styles.error}>First name is required</p>
                )}
              </div>
            </section>

            <section>
              <OnChangeInputField
                label="Last name"
                name="lastName"
                type="text"
                id="last-name-field"
                onChange={(e) => handleChange(e, "lastName")}
                value={lastName}
              />
              <div className={styles["insert-user-error-wrapper"]}>
                {errorLastName && (
                  <p className={styles.error}>Last name is required</p>
                )}
              </div>
            </section>

            <section>
              <OnChangeInputField
                label="Email"
                name="email"
                type="email"
                id="email-sign-in-field"
                pattern={/[0-9a-zA-Z]{6,}/}
                onChange={(e) => handleChange(e, "email")}
                value={email}
              />
              <div className={styles["insert-user-error-wrapper"]}>
                {errorEmail && (
                  <p className={styles.error}>Email is required</p>
                )}
              </div>
            </section>

            <section className="select-wrapper-role">
              <div className="label-wrapper">
                <label>Role </label>
              </div>
              <div>
                <select onChange={(e) => setRole(e.target.value)}>
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            </section>
            <section className={styles["insert-user-button-wrapper"]}>
              <Button type="submit">Submit</Button>
            </section>
          </form>
          <div className={styles["insert-user-error-wrapper"]}>
            {errorMessage && (
              <span className={styles.error}>{databaseErrorMessage}</span>
            )}
          </div>
          <div className={styles["loading-wrapper"]}>
            {loading && <p className={styles.loading}>Loading...</p>}
          </div>
        </div>
      )}
      {success && (
        <p>
          The new user is inserted into the database and a reset password email
          is sent.
        </p>
      )}
    </div>
  );
};

export default InsertUser;
